import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkOpen } from 'utils/util';
import CmsPreviewShell from "./CmsPreviewShell";

const formatPrice = (price) => price.toLocaleString("ko-KR") + "원~";

const RankingComponent = ({ title, subtitle, layout, items = [], categories = [] }) => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(
    categories.length > 0 ? categories[0] : null
  );
  const isCarousel = layout === "carousel";

  const renderCarouselItem = (item) => (
    <div key={item.id} className="cms-ranking__item" onClick={()=>{linkOpen(item.link, navigate)}}>
      <div className="cms-ranking__media">
        <div className="cms-ranking__thumb">
          <img src={item.img} alt={item.title} />
        </div>
        <span className="cms-ranking__rank">{item.rank}</span>
      </div>
      <div className="cms-ranking__body">
        <h5 className="cms-ranking__title">{item.title}</h5>
        <p className="cms-ranking__desc">{item.description}</p>
        <div className="cms-ranking__price-row">
          {item.discountRate && (
            <span className="cms-ranking__discount">{item.discountRate}%</span>
          )}
          {item.price > 0 && <span className="cms-ranking__price">{formatPrice(item.price)}</span>}
        </div>
      </div>
    </div>
  );

  const renderDefaultItem = (item) => (
    <div key={item.id} className="cms-ranking__item" onClick={()=>{linkOpen(item.link, navigate)}}>
      <div className="cms-ranking__media">
        <span className="cms-ranking__rank">{item.rank}</span>
        <div className="cms-ranking__thumb">
          <img src={item.img} alt={item.title} />
        </div>
      </div>
      <div className="cms-ranking__body">
        <h5 className="cms-ranking__title">{item.title}</h5>
        <p className="cms-ranking__desc">{item.description}</p>
        {item.price > 0 && <span className="cms-ranking__price">{formatPrice(item.price)}</span>}
      </div>
    </div>
  );

  return (
    <CmsPreviewShell title={title} subtitle={subtitle}>
  
      <div className={`cms-ranking cms-ranking--${layout}`}>
        {items.map((item) =>
          isCarousel ? renderCarouselItem(item) : renderDefaultItem(item)
        )}
      </div>
    </CmsPreviewShell>
  );
};

export default RankingComponent;
